import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Subscription } from "@/models/Subscription";
import { SubscriptionStatus } from "@/notifi_types";
import { computed } from "@vue/reactivity";
import { ref } from "vue";

/* global defineProps */

export default /*#__PURE__*/_defineComponent({
  props: {
  subscription: { type: Subscription, required: true },
  draggable: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props



const status = ref(props.subscription.status);
const pausing = ref(false);
const paused = computed(() => {
  return status.value == "paused";
});
const playPauseIcon = computed(() => {
  return paused.value ? "pause" : "play_arrow";
});
const togglePause = async (): Promise<void> => {
  pausing.value = true;
  if (paused.value) {
    status.value = SubscriptionStatus.active;
  } else {
    status.value = SubscriptionStatus.paused;
  }
  props.subscription.set("status", status.value);
  await props.subscription.save();
  pausing.value = false;
};
const allowEdit = computed((): boolean => {
  return true;
});

return (_ctx: any,_cache: any) => {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_list_item_section = _resolveComponent("va-list-item-section")!
  const _component_va_list_item_label = _resolveComponent("va-list-item-label")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_inner_loading = _resolveComponent("va-inner-loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_list_item = _resolveComponent("va-list-item")!

  return (_openBlock(), _createBlock(_component_va_list_item, null, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_va_list_item_section, { avatar: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_va_icon, { name: "drag_indicator" })
        ]),
        _: 1
      }, 512), [
        [_vShow, __props.draggable]
      ]),
      _createVNode(_component_va_list_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_va_list_item_label, null, {
            default: _withCtx(() => [
              _createVNode(_component_va_icon, {
                name: __props.subscription.typeIcon
              }, null, 8, ["name"]),
              _createTextVNode(" " + _toDisplayString(__props.subscription.name), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_va_list_item_section, { icon: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_va_inner_loading, {
            loading: pausing.value,
            size: 18
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_button, {
                size: "small",
                icon: _unref(playPauseIcon),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (togglePause()), ["prevent"])),
                color: _unref(paused) ? 'warning' : 'success'
              }, null, 8, ["icon", "color"])
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_router_link, {
            to: _unref(allowEdit) ? __props.subscription.url : ''
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_button, {
                class: "ml-1",
                size: "small",
                icon: "edit",
                disabled: !_unref(allowEdit)
              }, null, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})